import { render, staticRenderFns } from "./PaymentInitiationTest.vue?vue&type=template&id=510b2f96&scoped=true"
import script from "./PaymentInitiationTest.vue?vue&type=script&lang=js"
export * from "./PaymentInitiationTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b2f96",
  null
  
)

export default component.exports